import { Field, FieldProps } from '../Field';
import { Input, InputProps } from '../Input';

export type TextInputProps = FieldProps & InputProps;

const TextInput = Field(Input);

export default TextInput;
